import EmojiRatingPage from "@components/EmojiRatingPage"

export default function HairstyleStyleFeelingPage() {
  return (
    <EmojiRatingPage
      translationKey="styleFeelingHairstyle"
      leftLabelKey="notHappy"
      rightLabelKey="loveIt"
    />
  )
}
